import { Reducer } from "redux";

import ChoiceGroupFieldActionType from "common/fields/choiceGroupField/duck/actionTypes/choiceGroupFieldActionType";
import IDisplayFieldErrorAction from "common/fields/common/duck/actions/interfaces/IDisplayFieldErrorAction";
import IFieldControlState from "common/fields/common/interfaces/IFieldControlState";
import IResetFieldAction from "common/fields/common/duck/actions/interfaces/IResetFieldAction";
import IUpdateFieldValueAction from "common/fields/common/duck/actions/interfaces/IUpdateFieldValueAction";

type Action = IDisplayFieldErrorAction | IUpdateFieldValueAction | IResetFieldAction;

type CreateFieldControlReducer = (fieldName: string) => Reducer<IFieldControlState, Action>;

const defaultState: IFieldControlState = {
    value: "",
    errorMessage: "",
};

const choiceGroupFieldControlReducer: CreateFieldControlReducer =
    (fieldName: string): Reducer<IFieldControlState, Action> =>
        (state: IFieldControlState = defaultState, action: Action): IFieldControlState => {
            switch (action.type) {
                // Case when the server request fails. This should enable the dropdown field and display
                // the error message from the action's payload.
                case `${fieldName.toUpperCase()}_${ChoiceGroupFieldActionType.DISPLAY_CHOICE_GROUP_FIELD_ERROR}`:
                    const displayFieldErrorAction: IDisplayFieldErrorAction = action as IDisplayFieldErrorAction;

                    return {
                        ...state,
                        errorMessage: displayFieldErrorAction.payload.errorMessage,
                    };

                case `${fieldName.toUpperCase()}_${ChoiceGroupFieldActionType.UPDATE_CHOICE_GROUP_FIELD_VALUE}`:
                    const updateValueFieldAction: IUpdateFieldValueAction = action as IUpdateFieldValueAction;

                    return {
                        ...state,
                        value: updateValueFieldAction.payload.newValue,
                    };

                // This case is used to reset the state of the dropdown field back to the initial
                // (display) state with no error message.
                case `${fieldName.toUpperCase()}_${ChoiceGroupFieldActionType.RESET_CHOICE_GROUP_FIELD}`:
                    return {
                        ...state,
                        errorMessage: "",
                    };

                default:
                    return state;
            }
        };

export default choiceGroupFieldControlReducer;
